import React, { Component } from 'react';

class Attributions extends Component {
    render() {
        return (
            <>
                <div className="page-content bg-white">
                    <div className="banner-wraper">
                        <div className="page-banner" style={{ backgroundColor: '#f4f4f4', padding: '50px 0' }}>
                            <div className="container">
                                <div className="page-banner-entry text-center">
                                    <h1>Attributions</h1>
                                    <p className="mb-0">Acknowledging the creators of the icons and assets used on this website.</p>
                                    <p className="mb-0">This website is operated by Family EcoDental, LLC, doing business as Family Eco Dental.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="section-area section-sp1">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="attributions-list">
                                        <ul className="list-group">
                                            <li className="list-group-item">
                                                <strong>Website Template:</strong>{' '}
                                                <a href="https://themeforest.net/user/themetrades" target="_blank" rel="noreferrer">
                                                    ThemeTrades (ThemeForest)
                                                </a>
                                            </li>
                                            <li className="list-group-item">
                                                <strong>Dental Implant by Freepik:</strong>{' '}
                                                <a href="https://www.flaticon.com/free-icons/tooth" title="tooth icons">
                                                    Tooth icons created by Freepik - Flaticon
                                                </a>
                                            </li>
                                            <li className="list-group-item">
                                                <strong>Braces by Smashicons:</strong>{' '}
                                                <a href="https://www.flaticon.com/free-icons/dentist" title="dentist icons">
                                                    Dentist icons created by Smashicons - Flaticon
                                                </a>
                                            </li>
                                            <li className="list-group-item">
                                                <strong>Periodontics by CC:</strong>{' '}
                                                <div>
                                                    Icons made from{' '}
                                                    <a href="https://www.onlinewebfonts.com/icon">svg icons</a> is licensed by CC BY 4.0
                                                </div>
                                            </li>
                                            <li className="list-group-item">
                                                <strong>Whitening by Freepik:</strong>{' '}
                                                <a href="https://www.flaticon.com/free-icons/tooth" title="tooth icons">
                                                    Tooth icons created by Freepik - Flaticon
                                                </a>
                                            </li>
                                            <li className="list-group-item">
                                                <strong>X-Ray:</strong> Open Source
                                            </li>
                                            <li className="list-group-item">
                                                <strong>Filling by Freepik:</strong>{' '}
                                                <a href="https://www.flaticon.com/free-icons/dental" title="dental icons">
                                                    Dental icons created by Freepik - Flaticon
                                                </a>
                                            </li>
                                            <li className="list-group-item">
                                                <strong>Extraction by CC:</strong>{' '}
                                                <div>
                                                    Icons made from{' '}
                                                    <a href="https://www.onlinewebfonts.com/icon">svg icons</a> is licensed by CC BY 4.0
                                                </div>
                                            </li>
                                            <li className="list-group-item">
                                                <strong>Root Canal by HANIS:</strong>{' '}
                                                <a href="https://www.flaticon.com/free-icons/root-canal" title="root canal icons">
                                                    Root canal icons created by HANIS - Flaticon
                                                </a>
                                            </li>
                                            <li className="list-group-item">
                                                <strong>Bridge by Flowicon:</strong>{' '}
                                                <a href="https://www.flaticon.com/free-icons/teeth" title="teeth icons">
                                                    Teeth icons created by Flowicon - Flaticon
                                                </a>
                                            </li>
                                            <li className="list-group-item">
                                                <strong>Whitening by kerismaker:</strong>{' '}
                                                <a href="https://www.flaticon.com/free-icons/tooth" title="tooth icons">
                                                    Tooth icons created by kerismaker - Flaticon
                                                </a>
                                            </li>
                                            <li className="list-group-item">
                                                <strong>Denture by Victoruler:</strong>{' '}
                                                <a href="https://www.flaticon.com/free-icons/dental-implant" title="dental implant icons">
                                                    Dental implant icons created by Victoruler - Flaticon
                                                </a>
                                            </li>
                                            <li className="list-group-item">
                                                <strong>Crown by Culmbio:</strong>{' '}
                                                <a href="https://www.flaticon.com/free-icons/dental-crown" title="dental crown icons">
                                                    Dental crown icons created by Culmbio - Flaticon
                                                </a>
                                            </li>
                                            <li className="list-group-item">
                                                <strong>Dental Chair by Freepik:</strong>{' '}
                                                <a href="https://www.flaticon.com/free-icons/dentist" title="dentist icons">
                                                    Dentist icons created by Freepik - Flaticon
                                                </a>
                                            </li>
                                            <li className="list-group-item">
                                                <strong>Dental Drill by Swifticons:</strong>{' '}
                                                <a href="https://www.flaticon.com/free-icons/dentist" title="dentist icons">
                                                    Dentist icons created by Swifticons - Flaticon
                                                </a>
                                            </li>
                                            <li className="list-group-item">
                                                <strong>Doctor by Swifticons:</strong>{' '}
                                                <a href="https://www.flaticon.com/free-icons/nurse" title="nurse icons">
                                                    Nurse icons created by Swifticons - Flaticon
                                                </a>
                                            </li>
                                            <li className="list-group-item">
                                                <strong>Lotus by Pixel perfect:</strong>{' '}
                                                <a href="https://www.flaticon.com/free-icons/lotus" title="lotus icons">
                                                    Lotus icons created by Pixel perfect - Flaticon
                                                </a>
                                            </li>
                                            <li className="list-group-item">
                                                <strong>Tooth Check by Swifticons:</strong>{' '}
                                                <a href="https://www.flaticon.com/free-icons/dentist" title="dentist icons">
                                                    Dentist icons created by Swifticons - Flaticon
                                                </a>
                                            </li>
                                            <li className="list-group-item">
                                                <strong>Broken Tooth by Swifticons:</strong>{' '}
                                                <a href="https://www.flaticon.com/free-icons/teeth" title="teeth icons">
                                                    Teeth icons created by Swifticons - Flaticon
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </>
        );
    }
}

export default Attributions;